<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="1000px"
            :center="true"
            top="20px"
            :close-on-click-modal="false"
            :before-close="() => closeGameRuleDialog('GameRuleEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="GameRule"
                    ref="GameRuleEditForm"
                    label-width="100px"
                >
                    <div v-if="show_type">
                        <el-descriptions
                            class="margin-top"
                            :column="2"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>状态</span>
                                </template>
                                <el-select
                                    v-model="GameRule.state"
                                    filterable
                                    clearable
                                    placeholder="选择状态"
                                    class="state_c"
                                >
                                    <el-option
                                        v-for="item in AllState"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>关联代码</span>
                                </template>
                                <el-input v-model="GameRule.code" clearable></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>规则名称</span>
                                </template>
                                <el-input v-model="GameRule.name" clearable></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>规则颜色</span>
                                </template>
                                <el-radio-group v-model="GameRule.type" size="small" :fill="redio_color">
                                    <el-radio-button
                                        v-for="item in AllType"
                                        :key="item.name"
                                        :label="item.id"
                                    >{{item.name}}</el-radio-button>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>生效场景</span>
                                </template>
                                <el-select
                                    v-model="GameRule.circumstances"
                                    filterable
                                    clearable
                                    placeholder="选择场景"
                                    class="circumstances_c"
                                >
                                    <el-option
                                        v-for="item in AllCircumstances"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2>
                                <template slot="label">
                                    <span>互斥规则</span>
                                </template>
                                <el-input v-model="GameRule.incompatibility" clearable></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2>
                                <template slot="label">
                                    <span>规则内容</span>
                                </template>
                                <el-input type="textarea" :rows="3" v-model="GameRule.content"></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2>
                                <template slot="label">
                                    <div>规则说明</div>
                                </template>
                                <common-editor-component
                                    ref="greditor"
                                    :fcontent="GameRule.note"
                                ></common-editor-component>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div v-else>
                        <el-descriptions
                            class="margin-top"
                            :column="2"
                            :labelStyle="{'width':'120px','text-align':'center','font-weight':'bold'}"
                            :contentStyle="{'text-align': 'center','min-width':'260px'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>状态</span>
                                </template>
                                <el-tag size="small" type="info" v-if="GameRule.state === 0">移除</el-tag>
                                <el-tag size="small" type="success" v-else-if="GameRule.state === 1">正常</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>关联代码</span>
                                </template>
                                <span>{{ GameRule.code }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>规则名称</span>
                                </template>
                                <span v-if="GameRule.type === 1" style="color: #CE0000;font-weight: bold;">{{ GameRule.name }}</span>
                                <span v-else-if="GameRule.type === 2" style="color: #D9B300;font-weight: bold;">{{ GameRule.name }}</span>
                                <span v-else-if="GameRule.type === 3" style="color: #0080FF;font-weight: bold;">{{ GameRule.name }}</span>
                                <span v-else-if="GameRule.type === 4" style="color: #00A600;font-weight: bold;">{{ GameRule.name }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>规则颜色</span>
                                </template>
                                <span v-if="GameRule.type === 1" style="color: #CE0000;">红色</span>
                                <span v-else-if="GameRule.type === 2" style="color: #D9B300;">黄色</span>
                                <span v-else-if="GameRule.type === 3" style="color: #0080FF;">蓝色</span>
                                <span v-else-if="GameRule.type === 4" style="color: #00A600;">绿色</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>生效场景</span>
                                </template>
                                <span v-if="GameRule.circumstances ===0">无限制</span>
                                <span v-else-if="GameRule.circumstances ===1">5人以上身份场</span>
                                <span v-else-if="GameRule.circumstances ===2">7人以上身份场</span>
                                <span v-else-if="GameRule.circumstances ===3">8人身份场</span>
                                <span v-else-if="GameRule.circumstances ===4">全角色场</span>
                                <span v-else-if="GameRule.circumstances ===5">6人或8人身份全角色场</span>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2>
                                <template slot="label">
                                    <span>互斥规则</span>
                                </template>
                                <span>{{ GameRule.incompatibility }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2 :contentStyle="{'text-align':'left','white-space':'pre-line'}">
                                <template slot="label">
                                    <span>规则内容</span>
                                </template>
                                <span>{{ GameRule.content }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2 :contentStyle="{'text-align':'left','white-space':'pre-line'}">
                                <template slot="label">
                                    <div>规则说明</div>
                                </template>
                                <div class="el-tiptap-editor__content" v-html="GameRule.note"></div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改规则</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="CardFunDel('GameRuleEditForm')"
                        >删除规则</el-button
                    >
                    <el-button
                        plain
                        @click="closeGameRuleDialog('GameRuleEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('GameRuleEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('GameRuleEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeGameRuleDialog('GameRuleEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('GameRuleEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="$emit('cancel_edit')"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { GameRuleAddRequest,GameRuleDelRequest,GameRuleEditRequest } from '@/network/card/GameRule.js'

import CommonEditorComponent from '@/components/common/CommonEditorComponent'

export default {
    name: 'GameRuleEditComponent',
    data() {
        return {
            login_loading: false,
            GameRule: {
                state: '',
                code: '',
                name: '',
                type: '',
                circumstances: '',
                incompatibility: '',
                content: '',
                note: ''
            }
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '游戏规则详情'
            } else if (this.show_type === 1) {
                return '添加游戏规则'
            } else {
                return '修改游戏规则'
            }
        },
        redio_color() {
            let str = ''
            if(this.GameRule.type === 1) {
                str='#CE0000'
            } else if (this.GameRule.type === 2) {
                str='#D9B300'
            } else if (this.GameRule.type === 3) {
                str='#0080FF'
            } else if (this.GameRule.type === 4) {
                str='#00A600'
            }

            return str
        }
    },
    methods: {
        closeGameRuleDialog(formName) {
            this.resetForm(formName)
            this.$emit('exitGameRuleDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.GameRuleInsert(formName)
            })
        },
        GameRuleInsert(formName) {
            this.login_loading = true
            this.GameRule.note = this.$refs.greditor.content
            GameRuleAddRequest(this.GameRule)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitGameRuleDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.GameRule = {
                state: '',
                code: '',
                name: '',
                type: '',
                circumstances: '',
                incompatibility: '',
                content: '',
                note: ''
            }
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.GameRuleEdit(formName)
            })
        },
        GameRuleEdit(formName) {
            this.login_loading = true
            this.GameRule.id = this.id
            this.GameRule.note = this.$refs.greditor.content
            
            GameRuleEditRequest(this.GameRule)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitGameRuleDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.GameRule.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        GameRuleDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    GameRuleDelRequest(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeGameRuleDialog(formName))
                })
                .catch((err) => {})
        }
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        game_rule_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        AllState: {
            type: Array,
            default() {
                return []
            }
        },
        AllType: {
            type: Array,
            default() {
                return []
            }
        },
        AllCircumstances: {
            type: Array,
            default() {
                return []
            }
        },
        edit_auth: String,
        del_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        CommonEditorComponent
    },
    watch: {
        game_rule_details_data(newVal) {
            this.GameRule = newVal
        }
    },
}
</script>

<style lang='less' scoped>
.state_c {
    width: 100%;
}
.circumstances_c {
    width: 100%;
}
</style>